import React from 'react';
import { Hero } from './components/sections/Hero';
import { UrgencyStrip } from './components/sections/UrgencyStrip';
import { ProblemSolution } from './components/sections/ProblemSolution';
import { WhatYouBuild } from './components/sections/WhatYouBuild';
import { ChallengeSystem } from './components/sections/ChallengeSystem';
import { WhatsIncluded } from './components/sections/WhatsIncluded';
import { SupportCommunity } from './components/sections/SupportCommunity';
import { Results } from './components/sections/Results';
import { Bonus } from './components/sections/Bonus';
import { Pricing } from './components/sections/Pricing';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { StickyBar } from './components/ui/StickyBar';

function App() {
  return (
    <div className="min-h-screen bg-[#0B0E14] text-white font-['Inter']">
      <Hero />
      <UrgencyStrip />
      <ProblemSolution />
      <WhatYouBuild />
      <ChallengeSystem />
      <WhatsIncluded />
      <SupportCommunity />
      <Results />
      <Bonus />
      <Pricing />
      <FAQ />
      <FinalCTA />
      <StickyBar />
    </div>
  );
}

export default App;